import { PropsWithChildren } from 'react';
import { StyledSpacingWrapper } from './styled';

export function SpacingWrapper({
  children,
  shouldRemoveLeft
}: PropsWithChildren & { shouldRemoveLeft?: boolean }): JSX.Element {
  return (
    <StyledSpacingWrapper removeLeft={shouldRemoveLeft}>
      {children}
    </StyledSpacingWrapper>
  );
}
